module.exports = __webpack_public_path__ + "img/数.d3bd7e84.png";